import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const USE_MOCK_PAGE = process.env.REACT_APP_USE_MOCK_PAGE === "true";

const AuthButton = ({ style, customButtonName, onAuthSuccess }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate(); // Use useNavigate to programmatically navigate

  useEffect(() => {
    // Check if the user is already authenticated on component mount
    checkAuthentication();
  }, [onAuthSuccess]);

  const checkAuthentication = async () => {
    try {
      // Extract token from URL query parameters
      const urlParams = new URLSearchParams(window.location.search);
      const tokenFromURL = urlParams.get("token");

      // Check if a token exists in the URL query parameters
      if (tokenFromURL) {
        // Store the token in local storage
        localStorage.setItem("token", tokenFromURL);
        // Fetch user profile and pages
        await onAuthSuccess(tokenFromURL);
        setIsLoggedIn(true);
        // Redirect to app page
        navigate("/app");
      } else {
        // If no token in URL parameters, check if a token exists in local storage
        const token = localStorage.getItem("token");
        if (token) {
          await onAuthSuccess(token);
          setIsLoggedIn(true);
          navigate("/app");
        }
      }
    } catch (error) {
      console.error("Error during authentication:", error);
    }
  };

  const handleAuthClick = () => {
    try {
      if (USE_MOCK_PAGE) {
        const existingToken = localStorage.getItem("token");
        if (existingToken) {
          if (onAuthSuccess) {
            onAuthSuccess(existingToken);
          }
          navigate("/app");
        } else {
          navigate("/login");
        }
        return;
      }

      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      if (!backendUrl) {
        throw new Error("Backend URL is not defined");
      }
      // Redirect to backend for OAuth flow
      window.location.href = `${backendUrl}/auth/facebook`;
    } catch (error) {
      console.error("Error during authentication:", error);
    }
  };

  const handleLogoutClick = () => {
    // Clear the JWT token from local storage and set isLoggedIn to false
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    navigate("/"); // Redirect to the home page after logout
  };

  useEffect(() => {
    // Check if the user is already authenticated on component mount
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <div>
      {!isLoggedIn ? (
        <button style={style} onClick={handleAuthClick}>
          {customButtonName ? customButtonName : "Try with Facebook"}
        </button>
      ) : (
        <button style={style} onClick={handleLogoutClick}>
          Logout
        </button>
      )}
    </div>
  );
};

export default AuthButton;
